import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
export function HomeVideoContent() {
  return <div className="flex flex-col" data-id="element-1822">
      <span className="inline-block bg-storm-red text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-5 w-fit" data-id="element-1823">
        Watch Storm in Action
      </span>
      <h2 className="text-3xl md:text-4xl text-white mb-5 leading-tight" data-id="element-1824">
        See Storm Taekwondo Classes & Programs in Action
      </h2>
      <p className="text-base lg:text-lg text-gray-warm mb-6 leading-relaxed" data-id="element-1825">
        Watch how Storm students build confidence, focus, discipline, fitness,
        and real taekwondo skills in a structured, positive training
        environment.
      </p>

      <ul className="flex flex-col gap-3 mb-8 list-none p-0 m-0" data-id="element-1826">
        {['Kids, adults, and families welcome', 'Beginner-friendly classes for ages 3+', 'Confidence, discipline, fitness, and self-defense skills'].map(point => <li key={point} className="flex items-start gap-3 text-white leading-snug" data-id="element-1827">
            <CheckCircle2 className="w-5 h-5 text-storm-red shrink-0 mt-0.5" data-id="element-1828" />
            <span data-id="element-1829">{point}</span>
          </li>)}
      </ul>

      <div className="flex flex-col sm:flex-row gap-3" data-id="element-1830">
        <Link to="/SignMeUp" className="btn-primary text-center w-full sm:w-auto" data-id="element-1831">
          Start With a Trial Class
        </Link>
        <Link to="/Programs.html" className="btn-outline border-gray-warm text-white hover:bg-white hover:text-ink text-center w-full sm:w-auto" data-id="element-1832">
          View Classes & Programs
        </Link>
      </div>
    </div>;
}